/* eslint-disable jsx-a11y/anchor-is-valid */

import React from "react";
import home_1 from "../../assets/images/pictures/home_1.png";
import solPortal from "../../assets/images/home/sol-portal.png";
import solAgent from "../../assets/images/home/sol-agent.png";
import solApi from "../../assets/images/home/sol-api.png";
import DemandMfg from "../../assets/images/home/carrier/sản-xuất.png";
import DemandLog from "../../assets/images/home/carrier/logistic.png";
import DemandBank from "../../assets/images/home/carrier/ngân-hàng.png";
import DemandRe from "../../assets/images/home/carrier/bất-động-sản.png";
import DemandIns from "../../assets/images/home/carrier/bảo-hiểm.png";
import DemandHealth from "../../assets/images/home/carrier/y-tế.png";

import { useTranslation } from "react-i18next";
import { motion } from "framer-motion";
import routeVariants from "./../../assets/animates/routeVariants";
import Footer from "../global/Footer";
import NavbarBottom from "../global/NavbarBottom";
import FPT_CA from "../../assets/images/logos/CA/FPT-CA.png";
import VIETTEL_CA from "../../assets/images/logos/CA/viettel-ca.png";
import BKAV_CA from "../../assets/images/logos/CA/bkav-ca.png";
import VNPT_CA from "../../assets/images/logos/CA/vnpt-ca.png";
import EFY_CA from "../../assets/images/logos/CA/logo_efy.png";
import NACENCOMM from "../../assets/images/logos/CA/Untitled-removebg-preview.png";
import {
  moha as TrustMoha,
  circular08 as TrustTt08,
  decree337 as TrustNd337,
  decree13 as TrustNd13,
  vneid as TrustVneid,
  etl2023 as TrustEtl,
  iso as TrustIso,
} from "../../assets/images/trust/trustImages";
import { Link } from "react-router-dom";

const HOME_LAW_LINKS = {
  circular08:
    "https://vanban.chinhphu.vn/?pageid=27160&docid=218200&classid=1&typegroupid=6",
  decree337: "https://vanban.chinhphu.vn/?pageid=27160&docid=216284",
  decree13: "https://vanban.chinhphu.vn/?pageid=27160&docid=207759",
  etl2023: "https://vanban.chinhphu.vn/?pageid=27160&docid=208421",
  mohaEcontract:
    "https://hopdonglaodong.moha.gov.vn/landing-page/ncc-econtract",
};

const HOME_NEWS = [
  {
    image:
      "https://quantera.vn/blogs/wp-content/uploads/2026/08/he-sinh-thai-gopaperless-toan-dien.png",
    date: "12/08/2026",
    vi: {
      href: "https://quantera.vn/blogs/gopaperless-la-gi-giai-phap-so-hoa-hop-dong-dien-tu-chuan-nghi-dinh-337/",
      tag: "GoPaperless & eContract",
      title:
        "GoPaperless là gì? Giải pháp số hóa hợp đồng điện tử chuẩn Nghị định 337",
    },
    en: {
      href: "https://quantera.vn/blogs/en/what-is-gopaperless-electronic-contract-digitization-solution-compliant-with-decree-337/",
      tag: "GoPaperless & eContract",
      title:
        "What is GoPaperless? Electronic Contract Digitization Solution compliant with Decree 337",
    },
  },
  {
    image:
      "https://quantera.vn/blogs/wp-content/uploads/2026/09/trien-khai-so-hoa-phong-nhan-su-tu-a-z-768x644.png",
    date: "08/09/2026",
    vi: {
      href: "https://quantera.vn/blogs/huong-dan-trien-khai-so-hoa-phong-nhan-su-tu-a-den-z/",
      tag: "Chiến lược chuyển đổi số",
      title: "Hướng dẫn triển khai số hóa phòng nhân sự từ A đến Z",
    },
    en: {
      href: "https://quantera.vn/blogs/en/a-to-z-guide-to-hr-department-digitalization/",
      tag: "Digital Transformation Strategy",
      title: "A-to-Z Guide to HR Department Digitalization",
    },
  },
  {
    image:
      "https://quantera.vn/blogs/wp-content/uploads/2026/08/huong-dan-ky-hop-dong-lao-dong-dien-tu-chi-tiet-768x403.png",
    date: "26/08/2026",
    vi: {
      href: "https://quantera.vn/blogs/huong-dan-ky-hdld-dien-tu-de-dang/",
      tag: "Pháp lý chữ ký số",
      title:
        "Hướng dẫn ký HĐLĐ điện tử: 4 bước dễ dàng cho người lao động",
    },
    en: {
      href: "https://quantera.vn/blogs/en/easy-guide-to-sign-electronic-labor-contract/",
      tag: "Digital Signature Legal Framework",
      title:
        "Electronic Employment Contract Signing Guide: 4 Easy Steps for Employees",
    },
  },
  {
    image:
      "https://quantera.vn/blogs/wp-content/uploads/2026/08/top-3-nen-tang-econtract-chuan-nghi-dinh-337-768x403.png",
    date: "26/08/2026",
    vi: {
      href: "https://quantera.vn/blogs/top-3-nen-tang-econtract-chuan-nghi-dinh-337/",
      tag: "GoPaperless & eContract",
      title:
        "Top 3 nền tảng eContract chuẩn Nghị định 337 cho doanh nghiệp",
    },
    en: {
      href: "https://quantera.vn/blogs/en/top-3-econtract-platforms-compliant-with-decree-337/",
      tag: "GoPaperless & eContract",
      title:
        "Top 3 eContract Platforms Compliant with Decree 337 for Enterprises",
    },
  },
];

const CA_LOGOS = [
  { alt: "FPT-CA", src: FPT_CA },
  { alt: "VIETTEL-CA", src: VIETTEL_CA },
  { alt: "BKAV-CA", src: BKAV_CA },
  { alt: "VNPT-CA", src: VNPT_CA },
  { alt: "EFY-CA", src: EFY_CA },
  { alt: "NACENCOMM-CA", src: NACENCOMM, style: { height: "50px" } },
];

const HomeContent = () => {
  const { t, i18n } = useTranslation();
  const portalLogin = `https://gopaperless.mobile-id.vn/workflow/portal/login?language=${
    i18n.language || "vi"
  }`;
  const blogAll =
    i18n.language === "en"
      ? "https://quantera.vn/blogs/en/"
      : "https://quantera.vn/blogs/";

  const HOME_TRUST_BADGES = [
    {
      image: TrustMoha,
      title: t("landing.trust.c7.title"),
      sub: t("landing.trust.c7.sub"),
      href: HOME_LAW_LINKS.mohaEcontract,
      external: true,
    },
    {
      image: TrustTt08,
      title: t("landing.trust.c1.title"),
      sub: t("landing.trust.c1.sub"),
      href: HOME_LAW_LINKS.circular08,
      external: true,
    },
    {
      image: TrustNd337,
      title: t("landing.trust.c2.title"),
      sub: (
        <>
          {t("landing.trust.c2.sub")}
          {i18n.language === "vi" ? <br /> : null}
          {t("landing.trust.c2.sub2")}
        </>
      ),
      href: HOME_LAW_LINKS.decree337,
      external: true,
    },
    {
      image: TrustNd13,
      title: t("landing.trust.c3.title"),
      sub: (
        <>
          {t("landing.trust.c3.sub")}
          <br />
          {t("landing.trust.c3.sub2")}
        </>
      ),
      href: HOME_LAW_LINKS.decree13,
      external: true,
    },
    {
      image: TrustVneid,
      title: t("landing.trust.c4.title"),
      sub: t("landing.trust.c4.sub"),
      href: "/digital-signature#compliance",
    },
    {
      image: TrustEtl,
      title: t("landing.trust.c5.title"),
      sub: t("landing.trust.c5.sub"),
      href: HOME_LAW_LINKS.etl2023,
      external: true,
    },
    {
      image: TrustIso,
      title: t("landing.trust.c6.title"),
      sub: t("landing.trust.c6.sub"),
      href: "/digital-signature#compliance",
      scaleIso: true,
    },
  ];

  const SOLUTION_CARDS = [
    {
      key: "portal",
      img: solPortal,
      href: "/features-for-teams",
      bullets: ["b1", "b2", "b3"],
    },
    {
      key: "agent",
      img: solAgent,
      href: "/features-for-teams",
      bullets: ["b1", "b2"],
    },
    {
      key: "api",
      img: solApi,
      href: "/solutions",
      bullets: ["b1", "b2"],
    },
  ];

  return (
    <motion.div
      variants={routeVariants}
      initial="initial"
      animate="final"
      id="content"
      className="fs-navigation-overlay-content fs-navigation-overlay-left-content fs-navigation__0 bg-color-main no-transform"
    >
      <div className="container-fluid bg-color-home pt-73 pb-73">
        <div className="container px-md-0">
          <div className="col-sm-7 px-md-0 home-hero-copy">
            <p className="text-xs-center mb-20">
              <span className="home-hero-badge">
                {t("home-page.home-content.hero-title")}
              </span>
            </p>
            <h1 className="font-weight-bold font-60 text-white text-xs-center">
              {t("home-page.home-content.hero-point-1")}
              <br />
              {t("home-page.home-content.hero-point-2")}
              <br />
              <span className="text-yellow home-hero-accent">
                {t("home-page.home-content.hero-point-3")}
              </span>
            </h1>
            <p className="text-white text-xs-center pb-20">
              {t("home-page.home-content.hero-desc")}
            </p>
            <p className="text-xs-center pb-xs-20">
              <a
                className="btn-secondary background-size-none"
                href={portalLogin}
                target="_blank"
                rel="noreferrer"
              >
                {t("home-page.home-content.hero-cta")} →
              </a>
            </p>
          </div>
          <div className="col-sm-5 px-md-0 home-hero-visual">
            <div className="col-12">
              <img
                className="img-responsive mr-0"
                width="550px"
                src={home_1}
                data-no-retina
                alt="connection"
              />
            </div>
          </div>
        </div>
      </div>
      <div className="container-fuild flex center">
        <div className="triangle-middle-bottom"></div>
      </div>

      <div className="container-fluid home-trust-section">
        <div className="container px-md-0">
          <div className="home-trust-inner">
            {HOME_TRUST_BADGES.map((b, i) => (
              <a
                key={i}
                href={b.href}
                className="home-trust-badge"
                {...(b.external
                  ? { target: "_blank", rel: "noopener noreferrer" }
                  : {})}
              >
                <img
                  className={`home-trust-badge-img${b.scaleIso ? " home-trust-badge-img--iso" : ""}`}
                  src={b.image}
                  alt={b.title}
                />
                <div className="home-trust-badge-text">
                  <strong>{b.title}</strong>
                  <span>{b.sub}</span>
                </div>
              </a>
            ))}
          </div>
        </div>
      </div>

      <div className="container-fluid home-demand-section">
        <div className="container px-md-0">
          <h2 className="home-demand-title">
            {t("home-page.home-content.demand.title")}
          </h2>
          <div className="home-demand-inner">
            {[
              { key: "c1", image: DemandMfg },
              { key: "c2", image: DemandLog },
              { key: "c3", image: DemandBank },
              { key: "c4", image: DemandRe },
              { key: "c5", image: DemandIns },
              { key: "c6", image: DemandHealth },
            ].map((item) => (
              <div key={item.key} className="home-demand-card">
                <img
                  className="home-demand-img"
                  src={item.image}
                  alt={t(`home-page.home-content.demand.${item.key}.title`)}
                />
                <h3>{t(`home-page.home-content.demand.${item.key}.title`)}</h3>
                <p>{t(`home-page.home-content.demand.${item.key}.desc`)}</p>
                <span className="home-demand-cta">
                  {t("home-page.home-content.demand.cta")} →
                </span>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="container-fluid home-sol-section">
        <div className="container px-md-0">
          <h2 className="home-sol-title">
            {t("home-page.home-content.solution.title")}
          </h2>
          <div className="home-sol-grid">
            {SOLUTION_CARDS.map((card) => (
              <article key={card.key} className={`home-sol-card ${card.key}`}>
                <div className="home-sol-body">
                  <span className="home-sol-badge">
                    {t(`home-page.home-content.solution.${card.key}.badge`)}
                  </span>
                  <h3>
                    {t(`home-page.home-content.solution.${card.key}.title`)}
                  </h3>
                  <ul>
                    {card.bullets.map((b) => (
                      <li key={b}>
                        {t(`home-page.home-content.solution.${card.key}.${b}`)}
                      </li>
                    ))}
                  </ul>
                  <Link className="home-sol-link" to={card.href}>
                    {t("home-page.home-content.solution.learnmore")} →
                  </Link>
                </div>
                <div className="home-sol-visual">
                  <img
                    src={card.img}
                    alt={t(`home-page.home-content.solution.${card.key}.badge`)}
                  />
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>

      <div className="container-fluid home-why-section">
        <div className="container px-md-0">
          <h2 className="home-why-title">
            {t("home-page.home-content.why.title")}
          </h2>
          <div className="home-why-grid">
            {[
              { key: "c1", icon: "fas fa-shield-alt" },
              { key: "c2", icon: "fas fa-user-shield" },
              { key: "c3", icon: "fas fa-project-diagram" },
              { key: "c4", icon: "fas fa-users" },
              { key: "c5", icon: "fas fa-headset" },
            ].map((item) => (
              <div key={item.key} className="home-why-item">
                <div className={`home-why-ico ${item.key}`}>
                  <i className={item.icon} />
                </div>
                <h3>{t(`home-page.home-content.why.${item.key}.title`)}</h3>
                <p>{t(`home-page.home-content.why.${item.key}.desc`)}</p>
              </div>
            ))}
          </div>
          <div className="pt-30 pb-30 text-center">
            <p className="companies-text">
              {t("home-page.home-content.content-7")}
            </p>
            <ul className="list-inline text-center m-0">
              {CA_LOGOS.map((logo) => (
                <li key={logo.alt}>
                  <img
                    alt={logo.alt}
                    title={logo.alt}
                    className="client-s"
                    src={logo.src}
                    style={logo.style}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>

      <div className="container-fluid home-news-section">
        <div className="container px-md-0">
          <div className="home-news-head">
            <h2>{t("home-page.home-content.news.title")}</h2>
            <a
              className="home-news-all"
              href={blogAll}
              target="_blank"
              rel="noopener noreferrer"
            >
              {t("home-page.home-content.news.all")} →
            </a>
          </div>
          <div className="home-news-grid">
            {HOME_NEWS.map((post) => {
              const loc = i18n.language === "en" ? post.en : post.vi;
              return (
                <a
                  key={loc.href}
                  className="home-news-card"
                  href={loc.href}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img
                    className="home-news-img"
                    src={post.image}
                    alt={loc.title}
                  />
                  <div className="home-news-body">
                    <span className="home-news-tag">{loc.tag}</span>
                    <h3>{loc.title}</h3>
                    <div className="home-news-date">{post.date}</div>
                  </div>
                </a>
              );
            })}
          </div>
        </div>
      </div>

      <div className="container-fluid home-cta-section">
        <div className="container px-md-0">
          <div className="home-cta-banner">
            <div className="home-cta-left">
              <div className="home-cta-copy">
                <h2>{t("home-page.home-content.cta.title")}</h2>
                <p>{t("home-page.home-content.cta.desc")}</p>
              </div>
              <a
                className="btn-primary home-cta-btn"
                href={portalLogin}
                target="_blank"
                rel="noreferrer"
              >
                {t("home-page.home-content.cta.button")}
              </a>
            </div>
          </div>
        </div>
      </div>

      <Footer />
      <NavbarBottom />
    </motion.div>
  );
};

export default HomeContent;
